export const asapMinProductCount = 3;
export const asapBundleSlug = 'asap-bundles';